import React, { useState, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';

import { Toast } from 'primereact/toast';

import { ServicioObjetos } from '../../servicios/ServicioObjetos';
import { autenticar } from '../../servicios/ServicioAutenticacion';
import { ROOT_PATH } from '../../servicios/Constantes';
import { Message } from 'primereact/message';


export const Login = () => {

    const [usuario, setUsuario] = useState({});
    const [errores, setErrores] = useState({});
    const toast = useRef(null);
    const history = useHistory();

    const handleChange = e => {
        const { name, value } = e.target;
        setUsuario(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
    };



    

    const login=()=>{
        let erroresFrmLogin = validarFormularioLogin();
        setErrores(erroresFrmLogin);
        if (ServicioObjetos.esObjetoVacio(erroresFrmLogin)) {
            autenticar(usuario.usuario, usuario.contrasena).then(response => {
                history.push("/Nomifast/bienvenido");

            }).catch(error => {
                toast.current.show({ severity: 'error', summary: '', detail: error, life: 8000 });
            });
        }
    }
    const validarFormularioLogin = () => {
        const errores = {};
        if (ServicioObjetos.esObjetoVacio(usuario.usuario))
            errores.usuario = "El usuario es requerido";
        if (ServicioObjetos.esObjetoVacio(usuario.contrasena))
            errores.contrasena = "La contraseña es requerida";
        return errores;
    }


    return (
        
<div className="layout-main-container">

            <Toast ref={toast} />
            <div className="layout-main">
                <div className="grid" >
                    <div className="col-12 md:col-4 sm:col-12"></div>
                    <div className="col-12 md:col-4 sm:col-12 text-center">
                        <h1>Nomifast</h1>
                    </div>
                    <div className="col-12 md:col-4 sm:col-12"></div>
                </div>
                <div className="grid" >
                    <div className="col-12 md:col-4 sm:col-1"></div>
                    <div className="col-12 md:col-4 sm:col-12">
                        <div className="card p-fluid">
                            <h5>Inicio de sesión</h5>
                            <div className="field">
                                <label htmlFor="usuario">Usuario</label>
                                <InputText id="usuario" name="usuario" type="text" value={usuario.usuario || ""}
                                 onChange={handleChange} className={errores.usuario ? "p-invalid" : ""}/>
                                 {errores.usuario ? <div><Message severity="error" text={errores.usuario} /></div> : null}
                                
                            </div>
                            <div className="field">
                                <label htmlFor="contrasena">Contraseña</label>
                                <Password id="contrasena" name="contrasena" type="text"
                                     toggleMask feedback={false}  value={usuario.contrasena || ""}
                                     onChange={handleChange} className={errores.contrasena ? "p-invalid" : ""}  />
                                      {errores.contrasena ? <div><Message severity="error" text={errores.contrasena} /></div> : null}
                               
                            </div>
                            <Button label="Acceso" className="mr-2 mb-2" onClick={login} />
                            
                            
                        </div>
                    </div>
                    <div className="col-12 md:col-4 sm:col-1"></div>
                </div>
            </div>
        </div>
    );
}